/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component } from 'react';
import { Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import axios from 'axios';
import moment from 'moment';
import * as momentTz from 'moment-timezone';
import { Table } from 'react-bootstrap';

// project imports
import { getSellerUrl, getSellerHeaders } from 'shared/http';
import { invoiceDetail ,buyerlinkurl } from 'shared/settings/apiconfig';
import { FEE_TYPE_LIST } from 'shared/settings/config';
import toast from 'shared/toast';
import { capitalizeFirstLetter } from 'shared/utils';

// style imports
import '../invoice/InvoiceView.scss';
import './InvoiceView.scss'



/**
 * this page is used to view invoice
 * 
 * @param props
 * 
 * @returns html code to render the invoice view
 * 
**/

export default class InvoiceView extends Component {
    status = { 'paid': 'fa-check-circle', 'unpaid': 'fa-times-circle' }
    constructor(props) {
        super(props);
        this.state = {
            form: {
                id: this.props.id,
                billingto: {
                    name: '',
                    addressto1: '',
                    addressto2: '',
                    cityState: '',
                    countryZipcode: '',
                    email: '',
                    phonenumber: ''
                },
                billingfrom: {
                    contactname: '',
                    address1: '',
                    address2: '',
                    cityState: '',
                    countryZipcode: '',
                    contactemail: '',
                    contactmobile: ''
                },
                shippingto: {
                    address: '',
                    cityState: '',
                    countryZipcode: '',
                    showShippingAddress: false
                },
                child_invoice: [],
                selectedService: [],
                trackingid: '',
                items: [],
                total: '',
                buyerspremium: '',
                handling: '',
                shipping: '',
                applytaxonbp: '',
                totalbpamount: '',
                taxonBPamount: '',
                tax: '',
                grossamount: '',
                amountdue: '',
                status: '',
                createddate: '',
                timezone: '',
                saleid: '',
                totaltaxonbpamount: '',
                masterId : '',
                totalInvoiceAmount : '' ,
                totalInvoicePendingAmount : '' ,
                invoiceStatusAll : '' ,
                invoiceitemreceiptmethod: '',
                type: this.props.type,
                vipmember: false,
                creditStatus: false,

            },
            totalInvoiceAmount : 0,
            totalInvoicePendingAmount : 0,
            totalInvoiceAmountPaid : 0,
            windowWidth: window.innerWidth,
            loading: false,
            invoiceview: 0
        }
    }

    componentDidMount() {
        window.addEventListener('resize', this.updateDimensions);
        this.getInvoiceData();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
        if(this.props.location?.state?.state?.name === 'Saledashboard'){
        }else{
             window.removeEventListener('popstate', this.onBack);      
        }
    }

    /* Detect window width */
    updateDimensions = () => {
        this.setState({ windowWidth: window.innerWidth });
    };

    /* Get invoice data */
    getInvoiceData = () => {
        this.setState({ loading: true });
        axios.get(getSellerUrl(`${invoiceDetail}/${Number(this.state.form.id)}`), getSellerHeaders())
            .then(async response => {
                if (response.data.status === 'success') {
                    let data = response.data.data[0];
                    
                    this.setState({
                        invoiceview: data.invoiceview
                    })
                    if (data.masterinvoiceid && data.invoicestatus != 'Void') {
                        this.setState({
                            form: {
                                ...this.state.form,
                                id: data.masterinvoiceid,
                                totalInvoiceAmount: 0,
                                totalInvoicePendingAmount: 0,
                                totalInvoiceAmountPaid: 0
                            }
                        })
                        await this.getInvoiceData()
                    } else {
                    let invoiceData = JSON.parse(response.data.data[0].details);
                    const isCreditUsed = invoiceData.items.some(item => item.iscreditused === true);

                    let selectedService = [];
                    FEE_TYPE_LIST.map((item) => {
                        if (invoiceData[item.key]) {
                            selectedService.push({
                                ...item,
                                amount: invoiceData[item.key],
                                remark: invoiceData[item.key + "remark"],
                            })
                        }
                        return item
                    })
                    let child_invoice = data.child_invoice ? data.child_invoice : []
                    child_invoice = child_invoice.map((item) => {
                       
                        this.state.form.totalInvoiceAmount = Number(this.state.form.totalInvoiceAmount) + Number(item.invoiceamount);
                        this.state.form.totalInvoicePendingAmount = Number(this.state.form.totalInvoicePendingAmount) + Number(item.pendingamount);
                        let child_invoice_details = JSON.parse(item.details)
                        child_invoice_details["billingto"] = {
                            name: child_invoice_details["billingto"]["firstname"],
                            address1: child_invoice_details["billingto"]["address1"],
                            cityState: (`${child_invoice_details["billingto"]["city"] ? child_invoice_details["billingto"]["city"] : ""}
                                    ${child_invoice_details["billingto"]["state"] ? child_invoice_details["billingto"]["state"] : ""}`),
                            countryZipcode: (`${child_invoice_details["billingto"]["country"] ? child_invoice_details["billingto"]["country"] : ""}
                                    ${child_invoice_details["billingto"]["zipcode"] ? child_invoice_details["billingto"]["zipcode"] : ""}`),
                            email: child_invoice_details["billingto"]["email"],
                            phonenumber: child_invoice_details["billingto"]["mobile"],
                        }
                        child_invoice_details["billingfrom"] = {
                            contactname: child_invoice_details["billingfrom"]["contactname"],
                            address1: child_invoice_details["billingfrom"]["address1"],
                            cityState: (`${child_invoice_details["billingfrom"]["city"] ? child_invoice_details["billingfrom"]["city"] : ""}
                                    ${child_invoice_details["billingfrom"]["state"] ? child_invoice_details["billingfrom"]["state"] : ""}`),
                            countryZipcode: (`${child_invoice_details["billingfrom"]["country"] ? child_invoice_details["billingfrom"]["country"] : ""}
                                    ${child_invoice_details["billingfrom"]["zipcode"] ? child_invoice_details["billingfrom"]["zipcode"] : ""}`),
                            contactemail: child_invoice_details["billingfrom"]["contactemail"],
                            contactmobile: child_invoice_details["billingfrom"]["contactmobile"],
                        }
                        let child_invoice_selectedService = []
                        FEE_TYPE_LIST.map((item) => {
                            if (child_invoice_details[item.key]) {
                                child_invoice_selectedService.push({
                                    ...item,
                                    amount: child_invoice_details[item.key],
                                    remark: child_invoice_details[`${item.key}remark`],
                                })
                            }
                            return item
                        })
                        return ({
                            ...item,
                            details: child_invoice_details,
                            selectedService: child_invoice_selectedService,
                        })
                    })
                    let billingfromCityDelimiter = invoiceData.billingfrom.city && invoiceData.billingfrom.state ? ', ' : '';
                    let billingfromCountryDelimiter = invoiceData.billingfrom.country && invoiceData.billingfrom.zipcode ? ', ' : '';
                    let billingtoCityDelimiter = invoiceData.billingto.city && invoiceData.billingto.state ? ', ' : '';
                    let billingtoCountryDelimiter = invoiceData.billingto.country && invoiceData.billingfrom.zipcode ? ', ' : '';
                    let shippingtoCityDelimiter = invoiceData.billingfrom.city && invoiceData.billingfrom.state ? ', ' : '';
                    let shippingtoCountryDelimiter = invoiceData.billingfrom.country && invoiceData.billingfrom.zipcode ? ', ' : '';
                    this.setState({
                        form: {
                            ...this.state.form,
                            billingto: {
                                ...this.state.form.billingto,
                                name: invoiceData.billingto.lastname + ',' + invoiceData.billingto.firstname,
                                addressto1: (invoiceData.billingto.address1 ? invoiceData.billingto.address1 : '') + (billingtoCityDelimiter) + (invoiceData.billingto.address2 ? invoiceData.billingto.address2 + "," : ''),
                                cityState: (invoiceData.billingto.city ? invoiceData.billingto.city : '' )+ (billingtoCityDelimiter) + (invoiceData.billingto.state ? invoiceData.billingto.state : ''),
                                countryZipcode: (invoiceData.billingto.country ? invoiceData.billingto.country : '') + (billingtoCountryDelimiter) + (invoiceData.billingto.zipcode ? invoiceData.billingto.zipcode : ''),
                                email: invoiceData.billingto.contactemail ? invoiceData.billingto.contactemail : invoiceData.billingto.email ? invoiceData.billingto.email : '',
                                phonenumber: invoiceData.billingto.contactmobile ? invoiceData.billingto.contactmobile : invoiceData.billingto.mobile ? invoiceData.billingto.mobile : '',

                            },
                            billingfrom: {
                                ...this.state.form.billingfrom,
                                contactname: invoiceData.billingfrom.contactname ? invoiceData.billingfrom.contactname : '',
                                address1: invoiceData.billingfrom.address1 ? invoiceData.billingfrom.address1+','+invoiceData.billingfrom.address2 + ',': '',
                                cityState: (invoiceData.billingfrom.city ? invoiceData.billingfrom.city : '') + (billingfromCityDelimiter) + (invoiceData.billingfrom.state ? invoiceData.billingfrom.state : ''),
                                countryZipcode: (invoiceData.billingfrom.country ? invoiceData.billingfrom.country : '') + (billingfromCountryDelimiter) + (invoiceData.billingfrom.zipcode ? invoiceData.billingfrom.zipcode : ''),
                                contactemail: invoiceData.billingfrom.contactemail ? invoiceData.billingfrom.contactemail : invoiceData.billingfrom.email ? invoiceData.billingfrom.email : '',
                                contactmobile: invoiceData.billingfrom.contactmobile ? invoiceData.billingfrom.contactmobile : invoiceData.billingfrom.mobile ? invoiceData.billingfrom.mobile : '',

                            },
                            shippingto: {
                                ...this.state.form.shippingto,
                                address: (invoiceData?.shippingto?.address1 ? invoiceData?.shippingto?.address1 + ', ' : '') + (invoiceData?.shippingto?.address2 ? invoiceData?.shippingto?.address2 + ', ' : ''),
                                cityState: (invoiceData?.shippingto?.city ? invoiceData?.shippingto?.city : '') + (shippingtoCityDelimiter) + (invoiceData?.shippingto?.state ? invoiceData?.shippingto?.state : ''),
                                countryZipcode: (invoiceData?.shippingto?.country ? invoiceData?.shippingto?.country : '') + (shippingtoCountryDelimiter) + (invoiceData?.shippingto?.zipcode ? invoiceData?.shippingto?.zipcode : ''),
                                showShippingAddress: invoiceData?.shippingto ? true : false
                            },
                            selectedService,
                            child_invoice: child_invoice,
                            additionalnotes: data.additionalnotes ? data.additionalnotes : '',
                            trackingid: invoiceData.trackingid ? invoiceData.trackingid : '',
                            handling: invoiceData.handling,
                            shipping: invoiceData.shippinghandling,
                            additionalamount: invoiceData.additionalamount,
                            items: invoiceData.items,
                            status: data.invoicestatus,
                            invoiceamount: data.invoiceamount,
                            pendingamount: data.pendingamount,
                            invoicenumber: data.invoicenumber,
                            applytaxonbp: data.applytaxonbp,
                            invoicemessage: invoiceData.invoicemessage ? JSON.parse(invoiceData.invoicemessage).content.body : '',
                            createddate: data.createddate,
                            timezone: data.timezonename ? data.timezonename : '',
                            saleid: data.saleid != null ? data.saleid : "",
                            masterId : data.masterinvoiceid,
                            totalInvoiceAmount : data.invoiceamount ? (Number(this.state.form.totalInvoiceAmount) + Number(data.invoiceamount)) : Number(this.state.form.totalInvoiceAmount),
                            totalInvoiceAmountPaid : this.calculatePaymentReceived(data.invoiceamount, data.pendingamount),
                            totalInvoicePendingAmount : data.pendingamount ? (Number(this.state.form.totalInvoicePendingAmount) + Number(data.pendingamount)) : Number(this.state.form.totalInvoicePendingAmount),
                            invoiceitemreceiptmethod: data.invoiceitemreceiptmethod ? data.invoiceitemreceiptmethod : '',
                            vipmember: invoiceData.vipmember,
                            creditStatus : isCreditUsed,

                        },
                        loading: false
                    }, () => {
                        this.calculateTotal();
                    });
                }
                }
            })
            .catch(error => {
                toast.error(error.response.data['message']);
            });
    }
    calculatePaymentReceived = (invoiceAmount, pendingAmount) => {
        let totalInvoiceAmt = Number(this.state.form.totalInvoiceAmount)
        let totalPendingAmt = Number(this.state.form.totalInvoicePendingAmount)
        if(invoiceAmount) {
            totalInvoiceAmt += Number(invoiceAmount)
        }
        if(pendingAmount) {
            totalPendingAmt += Number(pendingAmount)
        }
        return totalInvoiceAmt - totalPendingAmt
    }

    /* calculate total for invoice amount, tax, buyerspremium */
    calculateTotal = () => {
        let amountTotal = 0;
        let taxTotal = 0;
        let taxamountTotal = 0;
        let buyerspremiumTotal = 0;
        let buyerspremiumamountTotal = 0;
        let taxonbuyerspremiumTotal = 0;
        let grossamountTotal = 0;
        this.state.form.items.forEach(item => {
            amountTotal = amountTotal + item.amount;
            taxTotal = taxTotal + item.tax;
            taxamountTotal = taxamountTotal + item.taxamount;
            buyerspremiumTotal = buyerspremiumTotal + item.buyerspremium;
            buyerspremiumamountTotal = buyerspremiumamountTotal + item.buyerspremiumamount;
            taxonbuyerspremiumTotal = taxonbuyerspremiumTotal + item.taxonBPamount;
            grossamountTotal = grossamountTotal + item.grossamount;

        });
        this.setState({
            form: {
                ...this.state.form,
                totaltax: taxTotal ? taxTotal : 0,
                totaltaxamount: taxamountTotal ? taxamountTotal : 0,
                totalbp: buyerspremiumTotal ? buyerspremiumTotal : 0,
                totalbpamount: buyerspremiumamountTotal ? buyerspremiumamountTotal : 0,
                totaltaxonbpamount: this.state.form.applytaxonbp ? (taxonbuyerspremiumTotal ? taxonbuyerspremiumTotal : 0) : 0,
                totalgrossamount: grossamountTotal ? grossamountTotal : 0,
                totalamount: amountTotal ? amountTotal : 0
            },
            loading: false
        });
    }


    render() {
        return (
            <div style={{ overflow: "auto", overflowY: "overlay" }}>
                {this.state.loading ?
                    <div className="d-flex flex-column align-items-center justify-content-center w-100 h-100" style={{ padding: "30%" }}>
                        <img src={`${process.env.PUBLIC_URL}/static/icons/table/option_1.gif`} alt="Please wait ....." height="100px" width="100px" />
                    </div> :
                    <div className="invoiceView buyerContainer container h-90 mt-3">
                        <div className="print" id="invoiceGenration">
                            <div className="d-flex flex-row p-4 border-bottom  flex-wrap">
                                <div className={` ${this.state.windowWidth > 426 ? 'justify-content-left text-left w-50' : 'justify-content-center text-center'} col-md-6 col-xs-12`}>
                                    <div className='d-flex align-items-center media-screen'>
                                        {this.state.form.type == "RA" || this.state.form.type == "DG" ? <img className="seel-img" style={{ borderRight: "4px solid #000000", height: "40px", marginLeft: "15px", paddingRight: "10px", width:'120px' }}  src={`${process.env.PUBLIC_URL}/static/logo/seel.png`} alt="logo" /> : ''}
                                        <img src={`${process.env.PUBLIC_URL}/static/logo/CTBids_logo.png`} style={{ marginLeft: "5px" }} alt="logo" height="60px" width="170px" />
                                    </div>
                                    { this.state.form.type == "RA" ? <div><b>Make it Returnable Provided By Seel</b></div> : this.state.form.type == "DG" ? <div><b>Delivery Guarantee Provided By Seel</b></div> : ''}                                
                                </div>
                                {/* <div className={` ${this.state.windowWidth > 426 ? 'justify-content-end text-right w-50 mt-3' : 'justify-content-center text-center mt-1'} col-xs-12 col-md-6`}>
                                    <h2 className="text-secondary invoicenumber">Invoice:{this.state.form.invoicenumber}</h2>
                                    <><i class={`fa ${this.status[this.state.form.status.toLowerCase()]} fa-lg pr-2 pt-1 ${this.state.form.status.toLowerCase() === 'paid' ? 'text-success' : 'text-danger'}`} aria-hidden="true"></i><span className={`${this.state.form.status.toLowerCase() === 'paid' ? 'text-success' : 'text-danger'}`}>{this.state.form.status.toUpperCase()}</span></>
                                </div> */}
                                <div className={`${this.state.windowWidth > 800 ? 'justify-content-end text-right w-50 mt-3' : 'justify-content-center text-center mt-1'}  col-md-6`}>
                                    {
                                        this.state.form.invoiceitemreceiptmethod && this.state.invoiceview && this.state.form.type != "RA" ?
                                            <span className="h4">Item Receipt Method: {this.state.form.invoiceitemreceiptmethod ? capitalizeFirstLetter(this.state.form.invoiceitemreceiptmethod) : "  - - -"}</span> : ""
                                    }
                                    { this.state.form.type == "RA" || this.state.form.type == "DG" ? 
                                        <div className={` text-secondary col-xs-12`}><div style={{ fontSize: "20px", whiteSpace: 'nowrap', color: '#00263E' }}><b className='text-secondary'>Invoice Type: </b>{this.state.form.type == "RA" ? "Make It Returnable (MIR)" : this.state.form.type == "DG" ? "Delivery Guaranteed (DG)" : "  - - -"}</div></div> : ""
                                    }
                                </div>
                            </div>
                            <div className={`${this.state.windowWidth > 800 && "d-flex row"} p-4  border-bottom mx-0 pickupStyle`}>
                                    <div className={`col col-xs-12 padding ${this.state.form.shippingto.showShippingAddress ? 'col-md-4' : 'col-md-6'}`}>
                                        <p><b className="text-secondary"> Billing To </b></p>
                                        {Object.keys(this.state.form.billingto).map((key) =>
                                            key === 'name' ? <p><b>{this.state.form.billingto[key]}</b></p> :
                                                key === 'phonenumber' ? this.state.form.billingto[key] ? <p style={{ color: "#1d9aa5" }}>Phone No: {this.state.form.billingto[key]}</p> : '' :
                                                    key === 'email' ? this.state.form.billingto[key] ? <p style={{ color: "#1d9aa5" }}>{this.state.form.billingto[key]}</p> : '' : <p style={{  wordBreak: 'break-all' }}>{this.state.form.billingto[key]}</p>
                                        )}
                                    </div>
                                    <div className={`col col-xs-12 padding ${this.state.form.shippingto.showShippingAddress ? 'col-md-4' : 'col-md-6'}`}>
                                        <p><b className="text-secondary">{this.state.form.type == "RA" || this.state.form.type == "DG" ? "Billing From" : "Pickup Location"}</b></p>
                                        {Object.keys(this.state.form.billingfrom).map((key) =>
                                            key === 'contactname' ? <p><b>{this.state.form.billingfrom[key]}</b></p> :
                                                key === 'contactmobile' ? this.state.form.billingfrom[key] ? <p style={{ color: "#1d9aa5" }}>Phone No: {this.state.form.billingfrom[key]}</p> : '' :
                                                    key === 'contactemail' ? this.state.form.billingfrom[key] ? <p style={{ color: "#1d9aa5" }}>{this.state.form.billingfrom.contactemail} </p> : '' : <p>{this.state.form.billingfrom[key]}</p>
                                        )}
                                    </div>
                                    {this.state.form.shippingto.showShippingAddress && this.state.form.type != "RA" && this.state.form.type != "DG"  ? <div className="col col-md-4 col-xs-12 padding">
                                        <p><b className="text-secondary">Shipping To</b></p>
                                        {Object.keys(this.state.form.shippingto).map((key) =>
                                            <p style={{  wordBreak: 'break-all' }}>{this.state.form.shippingto[key]}</p>
                                        )}
                                    </div> : ''}
                                </div>
                                <div className={` p-4 border-bottom mx-0`}>
                                    <div style={{ fontSize: "20px" }}><p><b className="text-secondary">Invoice Details</b></p></div>
                                </div>
                                <div className={`${this.state.windowWidth > 800 && "d-flex row"} p-4  mx-0 invoiceDate`}>

                                    <div className="col col-md-6 col-xs-12 padding"><div >
                                        <p className={` text-secondary col-xs-12`} ><b style={{ fontSize: "20px" }}>Invoice: {this.state.form.invoicenumber} </b>
                                        {<span className={`${this.state.form.status.toLowerCase() === 'paid' ? "text-success" : "text-danger"}`}>
                                            <i className={`fa ${this.status[this.state.form.status.toLowerCase()]} fa-lg pr-2 pt-1`} aria-hidden="true"></i>{this.state.form.status.toUpperCase()}</span>}</p></div></div>

                                    <div className="col col-md-6 col-xs-12 padding" style={{ textAlign: "right" }}>
                                        <p><b className="text-secondary">Invoice Date :- </b><b>{moment.utc(this.state.form.createddate).local().format('MM/DD/YYYY hh:mm A')} {momentTz.tz(momentTz.tz.guess()).zoneAbbr()}</b></p>
                                    </div>
                                </div>
                                {(this.state.form.items.length !== 0 ) ?
                                <div style={{ overflowX: "auto" }} className={` p-4 border-bottom mx-0`}>

                                    {this.state.form.items.length > 0 && <Table className="amountfields" responsive>
                                        <thead>
                                            <tr style={{ color: "#9F2241", flexWrap: "nowrap" }}>
                                                <td style={{ paddingLeft: "2.5rem" }}>Items</td>
                                                <td className='resp-sku'>SKU</td>
                                                {!this.state.invoiceview ? <td>IRM</td> : null}
                                                <td>{this.state.form.type == "RA" ? "MIR Amount" : this.state.form.type == "DG" ? "DG Amount" : "Amount" }</td>
                                                {this.state.form.type != "RA" && this.state.form.type != "DG" ?
                                                    <><td>Tax</td>
                                                        <td>Tax Amount</td>
                                                        <td>BP</td>
                                                        <td>BP Amount</td>
                                                        {this.state.form.applytaxonbp ? <td>BP Tax Amount</td> : ''}</> : ''}
                                                <td style={{ paddingRight: "2.5rem" }}>Gross Amount</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.state.form.items.map((item, index) => (
                                                    <tr>
                                                        <td style={{ paddingLeft: "2.5rem", width: '25%' }}><a href={item.itemviewurl ? item.itemviewurl : `${buyerlinkurl}${this.state.form.saleid}/item/${item.id}`} target="_blank">{item.title}</a></td>
                                                        <td style={{ wordBreak: 'break-all' }} className='resp-sku'>{item.SKU ? item.SKU : "- - -"}</td>
                                                        {!this.state.invoiceview ? <td style={{ whiteSpace: "nowrap" }}>{item.bidderirm ? capitalizeFirstLetter(item.bidderirm) : '- - -' }</td> : null }
                                                        <td style={{ whiteSpace: "nowrap" }}>{item.amount ? `$ ${parseFloat(item.amount).toFixed(2)}` : `- - - ${item.iscreditused ?  '**' : ''}`}</td>
                                                        {this.state.form.type != "RA" && this.state.form.type != "DG" ?
                                                            <><td style={{ whiteSpace: "nowrap" }}>{item.tax ? `${item.tax} %` : '- - -'}</td>
                                                                <td style={{ whiteSpace: "nowrap" }}>{item.taxamount ? `$ ${parseFloat(item.taxamount).toFixed(2)}` : '- - -'}</td>
                                                                <td style={{ whiteSpace: "nowrap" }}>{item.buyerspremium ? `${item.buyerspremium} %` : '- - -'}</td>
                                                                <td style={{ whiteSpace: "nowrap" }}>{item.buyerspremiumamount ? `$ ${parseFloat(item.buyerspremiumamount).toFixed(2)}` : '- - -'}</td>
                                                                {this.state.form.applytaxonbp ? <td style={{ whiteSpace: "nowrap" }}>{item.taxonBPamount ? `$ ${parseFloat(item.taxonBPamount).toFixed(2)}` : '- - -'}</td> : ''}</> : ''}
                                                        <td style={{ paddingRight: "2.5rem", whiteSpace: "nowrap" }}>{item.grossamount ? `$ ${parseFloat(item.grossamount).toFixed(2)}` : `- - -${item.iscreditused ?  '**' : ''}`}</td>
                                                    </tr>
                                                ))
                                            }
                                            <tr style={{ fontWeight: "bold", flexWrap: "nowrap" }}>
                                                <td></td>
                                                <td></td>
                                                {!this.state.invoiceview ? <td></td> : null}
                                                <td style={{ whiteSpace: "nowrap" }}>$ {parseFloat(this.state.form.totalamount).toFixed(2)}</td>
                                                {this.state.form.type != "RA" && this.state.form.type != "DG" ?
                                                    <><td></td>
                                                        <td style={{ whiteSpace: "nowrap" }}>$ {parseFloat(this.state.form.totaltaxamount).toFixed(2)}</td>
                                                        <td></td>
                                                        <td style={{ whiteSpace: "nowrap" }}>$ {parseFloat(this.state.form.totalbpamount).toFixed(2)}</td>
                                                        {this.state.form.applytaxonbp ? <td style={{ whiteSpace: "nowrap" }}>$ {parseFloat(this.state.form.totaltaxonbpamount).toFixed(2)}</td> : ''}</> : ''}
                                                <td style={{ whiteSpace: "nowrap" }}>$ {parseFloat(this.state.form.totalgrossamount).toFixed(2)}</td>
                                            </tr>
                                        </tbody>
                                    </Table>}

                                </div> : 
                            <div className="serviceview" style={{ padding: '0 1% 0 1%' }}>
                            <Table className="amountfields" responsive style={{ height: "100%" }}>
                                <thead>
                                    <tr style={{ color: "#9F2241", flexWrap: "nowrap" }}>
                                        <td style={{ textAlign: "left" }}>Services</td>
                                        <td style={{ textAlign: "left" }}>Description</td>
                                        <td style={{ textAlign: "right", paddingRight: "1.5rem" }}>Amount</td>
                                    </tr>
                                </thead>
                                {this.state.form.selectedService.map((item, index) => (
                                    <tr>
                                        <td style={{ textAlign: "left", width: "30%" }}>{item.name}</td>
                                        <td style={{ textAlign: "left", width: "45%" }}>{item.remark ? item.remark : "- - -"}</td>
                                        <td style={{ textAlign: "right", paddingRight: "1.5rem" }}>{item.amount ? `$ ${parseFloat(item.amount).toFixed(2)}` : '- - -'}</td>
                                    </tr>
                                ))}
                                
                            </Table>
                            <Row className="" >
                                <Col></Col>
                                <Col className="text-right text-secondary" ><b>Total Amount</b></Col>
                                <Col style={{ paddingLeft: this.state.windowWidth > 430 ? "3px" : "7px" }} className="text-end text-secondary"><b>{this.state.form.invoiceamount ? `$ ${parseFloat(this.state.form.invoiceamount).toFixed(2)}` : '- - -'}</b></Col>
                            </Row>
                        </div>
                            }
                            { this.state.form.type != "RA" && this.state.form.type != "DG" ? <div className={`${this.state.windowWidth > 800 ? "d-flex flex-column-reverse" : ""} , p-4 border-bottom mx-0`} style={{ margin: "2% 5%" }}>
                                {this.state.form.additionalnotes ? <p><b className="text-secondary" style={{ paddingLeft: "15px" }}> Additional Notes </b>{this.state.form.additionalnotes ?
                                    <OverlayTrigger className="no-print" trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{this.state.form.additionalnotes}</Tooltip>}>
                                        <i className={`fa fa-question-circle no-print`} style={{ fontSize: "14px" }}></i>
                                    </OverlayTrigger> : ""}
                                </p> : ""
                                }
                                {(this.state.form.masterId == null || this.state.form.masterId == '' ) ? <div className="serviceview" >
                                    {this.state.form.selectedService.map((item, index) => (
                                        <Row className="">
                                            <Col className="text-left text-secondary" ><b>{item.name}</b></Col>
                                            <Col>{item.remark ? item.remark : "- - -"}</Col>
                                            <Col style={{ paddingLeft: this.state.windowWidth > 430 ? "3px" : "7px" }} className="text-end text-secondary"><b>{item.amount ? `$ ${parseFloat(item.amount).toFixed(2)}` : '- - -'}</b></Col>
                                        </Row>
                                    ))}
                                    <Row className="" >
                                        <Col></Col>
                                        <Col className="text-right text-secondary" ><b>Total Amount</b></Col>
                                        <Col style={{ paddingLeft: this.state.windowWidth > 430 ? "3px" : "7px" }} className="text-end text-secondary"><b>{this.state.form.invoiceamount ? `$ ${parseFloat(this.state.form.invoiceamount).toFixed(2)}` : '- - -'}</b></Col>
                                    </Row>

                                </div> : ''}
                            </div> : '' }
                            <div className={` p-4 mx-0`}>
                                {this.state.form.child_invoice &&
                                    this.state.form.child_invoice.map((data, key) => (
                                        <div className=" h-20 mt-1" >
                                            <div className="">
                                                <div className="print" >
                                                    <div className="childInvoice">
                                                        <div className={`${this.state.windowWidth > 800 && "d-flex row"} invoiceDate`}>
                                                        <div className="col col-md-6 col-xs-12 padding">
                                                                    <div className="text-secondary"><b style={{ fontSize: "20px" }}>Invoice: {data.invoicenumber} </b>    {<span className={`${data.invoicestatus.toLowerCase() === 'paid' ? "text-success" : "text-danger"}`}>
                                                                        <i className={`fa ${this.status[data.invoicestatus.toLowerCase()]} fa-lg pr-2 pt-1`} aria-hidden="true"></i>{data.invoicestatus.toUpperCase()}</span>}
                                                                    </div>
                                                                </div>

                                                            <div className="col col-md-6 col-xs-12 padding" style={{ textAlign: "right" }}>
                                                                <p><b className="text-secondary">Invoice Date :- </b> <b> {moment.utc(data.createddate).local().format('MM/DD/YYYY hh:mm A')} {momentTz.tz(momentTz.tz.guess()).zoneAbbr()}</b></p>
                                                            </div>
                                                        </div>
                                                        <div className={`${this.state.windowWidth > 800 ? "d-flex flex-column-reverse" : ""}`} >
                                                            {data.additionalnotes ? <p><b className="text-secondary" style={{ paddingLeft: "15px" }}> Additional Notes </b> {data.additionalnotes ?
                                                                <OverlayTrigger className="no-print" trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{data.additionalnotes}</Tooltip>}>
                                                                    <i className={`fa fa-question-circle no-print`} style={{ fontSize: "14px" }}></i>
                                                                </OverlayTrigger> : ''}
                                                                <div className={data.additionalnotes ? 'viewonlyinprint' : ''}>
                                                                    {data.additionalnotes}
                                                                </div>
                                                            </p> : ''}
                                                            <div className="serviceview" >
                                                                <div >
                                                                    {data.selectedService.length > 0 && <Table className="amountfields" responsive style={{ height: "100%" }}>
                                                                        <thead>
                                                                            <tr style={{ color: "#9F2241", flexWrap: "nowrap" }}>
                                                                                <td style={{ textAlign: "left" }}>Services</td>
                                                                                <td style={{ textAlign: "left" }}>Description</td>
                                                                                <td style={{ textAlign: "right", paddingRight: "1.5rem" }}>Amount</td>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {
                                                                                data.selectedService.map((item, index) => (
                                                                                    <tr>
                                                                                        <td style={{ textAlign: "left", width: "30%" }}>{item.name}</td>
                                                                                        <td style={{ textAlign: "left", width: "45%" }}>{item.remark ? item.remark : "- - -"}</td>
                                                                                        <td style={{ textAlign: "right", paddingRight: "1.5rem" }}>{item.amount ? `$ ${parseFloat(item.amount).toFixed(2)}` : '- - -'}</td>
                                                                                    </tr>
                                                                                ))
                                                                            }

                                                                        </tbody>
                                                                    </Table>
                                                                    }
                                                                </div>
                                                                <Row className="" >
                                                                    <Col></Col>
                                                                    <Col className="text-right text-secondary" ><b>Total Amount</b></Col>
                                                                    <Col style={{ paddingLeft: this.state.windowWidth > 430 ? "3px" : "7px" }} className="text-end text-secondary"><b>{data.invoiceamount ? `$ ${parseFloat(data.invoiceamount).toFixed(2)}` : '- - -'}</b></Col>
                                                                </Row>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                            <div className="serviceview">
                                    <Row className="" >
                                        <Col></Col>
                                        <Col className="text-right text-secondary" ><b>Total Amount</b></Col>
                                        <Col style={{ paddingLeft: this.state.windowWidth > 430 ? "3px" : "7px" }} className="text-end text-secondary"><b style={{ paddingRight: "10%" }}>{this.state.form.totalInvoiceAmount ? `$ ${parseFloat(this.state.form.totalInvoiceAmount).toFixed(2)}` : '$ 0.00'}</b></Col>
                                    </Row>
                                    {this.state.form.vipmember ? 
                                    <Row className="" >
                                        <Col></Col>
                                        <Col className="text-right text-secondary" ><b>Your Cost</b></Col>
                                        <Col style={{ paddingLeft: this.state.windowWidth > 430 ? "15px" : "7px" }} className="text-end text-secondary"><b style={{ paddingRight: "10%" }}>{"$ 0.00"}</b></Col>
                                    </Row> : 
                                    <Row className="" >
                                        <Col></Col>
                                        <Col className="text-right text-secondary" ><b>Payments Received </b></Col>
                                        <Col style={{ paddingLeft: this.state.windowWidth > 430 ? "3px" : "7px" }} className="text-end text-secondary"><b style={{ paddingRight: "10%" }}>{this.state.form.totalInvoiceAmountPaid ? `$ ${parseFloat(this.state.form.totalInvoiceAmountPaid).toFixed(2)}` : '$ 0.00'}</b></Col>
                                    </Row>}
                                    {this.state.form.type !== "RA" && this.state.form.type !== "DG" ?<Row className="" >
                                        <Col></Col>
                                        <Col className="text-right text-secondary" ><b>Remaining Amount Due </b></Col>
                                        <Col style={{ paddingLeft: this.state.windowWidth > 430 ? "3px" : "7px" }} className="text-end text-secondary"><b style={{ paddingRight: "10%" }}>{this.state.form.totalInvoicePendingAmount ? `$ ${parseFloat(this.state.form.totalInvoicePendingAmount).toFixed(2)}` : '- - -'}</b></Col>
                                    </Row> : ''}
                                </div>

                                {this.state.form.creditStatus && this.state.form.type == "DG"  ? <h5 className='pr-4 my-5' style={{ paddingLeft: "4%" }} >
                                    ** Premier member credit applied  
                                    </h5> : ''}
                            <div className="px-5 py-2 invoice-message-wraper" dangerouslySetInnerHTML={{ __html: this.state.form.invoicemessage }}>

                                {/* <div>
                                    <h6 className="text-secondary">Comments:</h6>
                                    <p>Thank you for supporting Caring Transitions to assist another family in transition. Payment Due Date: Immediately Upon Receipt of Invoice</p>
                                </div>
                                <div>
                                    <h6 className="text-secondary">Pickup Date/Time:</h6>
                                    <p>Pickup Date and Time will be listed for the individual items as they may be from multiple locations</p>
                                </div>
                                <div>
                                    <h6 className="text-secondary">Pickup Location:</h6>
                                    <p>Location may vary based on the item. Please review the individual listing for item location</p>
                                </div>
                                <div className="padding">
                                    <h6 className="text-secondary">Contact Us:</h6>
                                    <p style={{ color: "#1d9aa5" }}>AuctionAdminCLE@CaringTransitions.com</p>
                                    <p>Call or text (440)463-9659</p>
                                </div>
                            </div>
                            <div className="px-5 py-2">
                                <b>Please bring necessary tools and help for picking up large items.Loading assistance will not be available. Some items may be located in the basement second floor. Please bring boxes or totes for smaller items to carry away.</b>
                                <p className="pt-1 px-4 text-center">Thank you again for purchasing at the caring Transitions of ClevelandWS & Beachwood online auction location;your business is appreciated. </p> */}
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}